import { Injectable } from '@angular/core';
import { DriverTransactionResponse, GetTransactionResponse, TransactionRequest } from '@core/models/transaction.model';
import { APIService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(private readonly apiService: APIService) {

  }

  getTransactionsByOwner(transactionRequest: TransactionRequest): Observable<GetTransactionResponse> {
    return this.apiService.post<GetTransactionResponse>(`BookingSlot/GetTransactionsByOwner`, transactionRequest);
  }


  getHighestPaymentOfDriver(transactionRequest: TransactionRequest): Observable<DriverTransactionResponse[]> {
    return this.apiService.post<DriverTransactionResponse[]>(`BookingSlot/GetHighestPaymentOfDriver`, transactionRequest);
  }

  getTransactionOverview(request) {
    return this.apiService.postWithAllResponse('BookingSlot/GetTransactionOverview', request);
  }
  getTransActionBySuperAdmin(request) {
    return this.apiService.postWithAllResponse('BookingSlot/GetTransactionOverviewInGraphBySuperAdmin', request)
  }
  getParkingLotInvoiceForDriverCustom(req){
  return this.apiService.postWithAllResponse('ParkingLot/GetParkingLotInvoiceForDriverCustom',req)
  }

}
